import { render, staticRenderFns } from "./trade-deficit-mp1c.vue?vue&type=template&id=765c5d38&"
import script from "./trade-deficit-mp1c.vue?vue&type=script&lang=js&"
export * from "./trade-deficit-mp1c.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})


/* hot reload */
if (module.hot) {
  var api = require("/home/application/eu/trade-dsm-frontend_2022/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('765c5d38')) {
      api.createRecord('765c5d38', component.options)
    } else {
      api.reload('765c5d38', component.options)
    }
    module.hot.accept("./trade-deficit-mp1c.vue?vue&type=template&id=765c5d38&", function () {
      api.rerender('765c5d38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/trade-dsm-application/graphs/mp1c/trade-deficit-mp1c.vue"
export default component.exports